import * as React from "react"
import { UserCtxProvider } from "../UserCtx"
import { CompanyCtxProvider } from "../CompanyCtx"

export const AppCtxProvider: React.FC<{
	children: React.ReactNode
}> = ({ children }) => (
	<UserCtxProvider>
		<CompanyCtxProvider>{children}</CompanyCtxProvider>
	</UserCtxProvider>
)
